<template>
	<section id="content" class="content main-cont" role="main">
		<!-- Main ContentsHeader -->
		<div class="content-header">
			<!-- 메인비주얼 -->
			<div class="main-visual-wrap">
				<div class="swiper-wrap mainBanner"> <!-- 2019.07.17 Add 홍병기K (C20190711_39469 반영) -->
					<div class="swiper-wrap">
						<div class="swiper-mainVisual swiper-container">
							<div class="swiper-wrapper">
								<!-- 테스트 하드코딩 -->
								<!-- 사용자정의 프로모션 -->
                                <!-- start-2021.12.20 송준형 : REQSDP-1104 - PC mall(https://kr.lgappstv.com) 디폴트 배너 삭제 건 -->
								<!--<div class="swiper-slide swiper-custom" role="img" aria-label="Make the most of your smart life with LG Content Store">
									<div class="bg-area" aria-hidden="true"></div>
									<div class="in-sec" aria-hidden="true">
										<div class="title-area">
											<p class="explain">Make the most of your smart life</p>
											<p class="title" role="text">With <em>LG Content Store</em></p>
										</div>
										&lt;!&ndash; TV 영역 &ndash;&gt;
										<div class="tv-area" aria-hidden="false">
											<div class="btm"></div>&lt;!&ndash; TV 받침 &ndash;&gt;
											<div class="monitor"><img src="/img/cnt/main_visual_1_monitor.png" alt="" /></div>&lt;!&ndash; TV 모니터 &ndash;&gt;
											<div class="ch1"><img src="/img/cnt/main_visual_1_ch1.png" alt="" /></div>&lt;!&ndash; TV 모니터 채널1 &ndash;&gt;
											<div class="ch2"><img src="/img/cnt/main_visual_1_ch2.png" alt="" /></div>&lt;!&ndash; TV 모니터 채널2 &ndash;&gt;
											<div class="ch3"><img src="/img/cnt/main_visual_1_ch3.png" alt="" /></div>&lt;!&ndash; TV 모니터 채널3 &ndash;&gt;
											<div class="shadow"></div>&lt;!&ndash; TV 그림자 &ndash;&gt;
										</div>
									</div>
								</div>
								&lt;!&ndash; C20190819_65828 : 2019.08.22 김남중 - PC Website Main Promotion Banner 링크 오류 수정 : template v-if="cntryCode == 'US'" 처리 및 target="_blank" 삭제 &ndash;&gt;
								<template v-if="cntryCode == 'US'">
									&lt;!&ndash; S : 2019.07.17 Add 홍병기K (C20190711_39469 반영) &ndash;&gt;
									<div class="swiper-slide lgchannels" role="img" aria-label="LG Channels 160+ FREE Streaming Channels Now Available" v-show="cntryCode == 'US'">
										&lt;!&ndash; a href="https://www.lg.com/us/tv-audio-video/lg-channels" target="blank" title="" &ndash;&gt;
										&lt;!&ndash; C20190723_47503 : 2019.08.08 김남중 - 옴니추어 Main Swiper 배너 이미지 Link &ndash;&gt;
										<a href="javascript:;" title="" @click="bannerClick('https://www.lg.com/us/tv-audio-video/lg-channels');">
											<div class="bg"></div>
											<div class="inner lgchannelsWrap">
												<div class="circle-group">
													<div class="cricle2"></div>
													<div class="cricle1"></div>
													<div class="cricle3"></div>
													<div class="cricle4">LG Channels</div>
													<div class="cricle5">160+ FREE Streaming Channels Now Available</div>
												</div>
											</div>
										</a>
									</div>
									&lt;!&ndash; E : 2019.07.17 Add 홍병기K (C20190711_39469 반영) &ndash;&gt;
									<a href="javascript:;" class="swiper-slide" v-for="banner in bannerList" :title="$t('gwa.alt.common.wa_title_4')" @click="bannerClick(banner.lnkUrl);">
										<div class="swiper-slide-item" :style="'background-image:url('+banner.imgFile+'); background-position:'+ banner.posi +' center;'" role="text">LG Content Store Promotion</div>
									</a>
								</template>
								&lt;!&ndash; C20190819_65828 : 2019.08.22 김남중 - PC Website Main Promotion Banner 링크 오류 수정 : template v-if="cntryCode != 'ZZ' && bannerList.length > 0" 처리 및 target="_blank" 삭제 &ndash;&gt;
								<template v-if="cntryCode != 'US'">
									<a href="javascript:;" class="swiper-slide" v-for="banner in bannerList" :title="$t('gwa.alt.common.wa_title_4')" @click="bannerClick(banner.lnkUrl);">
										&lt;!&ndash;<div class="swiper-slide-item" v-if="banner.posi == null || banner.posi == ''" role="image" :style="'background-image:url('+banner.imgFile+'); background-position:right center;'" aria-label="Make the most of your smart life with LG Content Store" @click="bannerClick(banner.lnkUrl);"></div>&ndash;&gt;
										<div class="swiper-slide-item" :style="'background-image:url('+banner.imgFile+'); background-position:'+ banner.posi +' center;'" role="text">LG Content Store Promotion</div>
									</a>
								</template>-->
                                <template>
                                  <!-- 2025.05.29 송준형 : REQSDP-7378 - lgappstv.com 한국 웹접근성 심사결과 대응 2025년 (잔여) -->
                                    <a href="javascript:;" id="bannerSlide" class="swiper-slide" v-for="banner in bannerList" :title="$t('gwa.alt.common.wa_title_4')" @click="bannerClick(banner.lnkUrl);">
                                        <!--<div class="swiper-slide-item" v-if="banner.posi == null || banner.posi == ''" role="image" :style="'background-image:url('+banner.imgFile+'); background-position:right center;'" aria-label="Make the most of your smart life with LG Content Store" @click="bannerClick(banner.lnkUrl);"></div>-->
										<!-- 2023.06.13 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년 -->
                                        <div class="swiper-slide-item" :style="'background-image:url('+banner.imgFile+'); background-position:'+ banner.posi +' center;'" role="text">{{ banner.titleName }}</div>
                                    </a>
                                </template>
                                <!-- end-2021.12.20 송준형 : REQSDP-1104 - PC mall(https://kr.lgappstv.com) 디폴트 배너 삭제 건 -->
								<!--<div class="swiper-slide" v-for="banner in bannerList" ><div class="swiper-slide-item" role="image" :style="'background-image:url('+banner.imgFile+'); background-position:20% center;'" aria-label="Make the most of your smart life with LG Content Store"></div></div>-->
								<!-- //사용자정의 프로모션 -->
								<!-- 관리자등록 프로모션 -->
								<!--<div class="swiper-slide"><div class="swiper-slide-item" role="image" style="background-image:url(/upload/@main_visual_2.png)" aria-label="Make the most of your smart life with LG Content Store"></div></div>-->
								<!--<div class="swiper-slide" v-for="banner in bannerList" :style=" 'background-image:url('+banner.imgFile+')'" role="image" aria-label="Make the most of your smart life with LG Content Store"></div>-->
								<!--<div class="swiper-slide"><div class="swiper-slide-item" role="image" style="background-image:url(/upload/@main_visual_3.png)" aria-label="Make the most of your smart life with LG Content Store"></div></div>
								<div class="swiper-slide"><div class="swiper-slide-item" role="image" style="background-image:url(/upload/@main_visual_2.png)" aria-label="Make the most of your smart life with LG Content Store"></div></div>
								<div class="swiper-slide"><div class="swiper-slide-item" role="image" style="background-image:url(/upload/@main_visual_3.png)" aria-label="Make the most of your smart life with LG Content Store"></div></div>-->
								<!-- //관리자등록 프로모션 -->
								<!-- //테스트 하드코딩 -->
							</div>
							<!-- 2024.06.14 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
							<div class="swiper-controller">
								<div class="swiper-autoplay">
									<button type="button" class="btn-ico btn-play"><span><i class="ico ico-play-visual">{{ $t('gwa.alt.common.wa_label_2') }}</i></span></button>
									<button type="button" class="btn-ico btn-pause" aria-hidden="true" tabindex="-1"><span><i class="ico ico-pause-visual">{{ $t('gwa.alt.common.wa_label_3') }}</i></span></button>
								</div>
								<div class="swiper-pagination"></div>
							</div>
						</div>
					</div>
				</div> <!-- 2019.07.17 Add 홍병기K (C20190711_39469 반영) -->
			</div>
			<!-- Add "scoped" attribute to limit CSS to this component only -->
			<!-- //메인비주얼 -->
		</div>
		<!-- //Main ContentsHeader -->

		<!-- Main ContentsBody -->
		<div class="content-body">
			<!-- 공지사항 -->
			<div class="section-wrap main-notice-wrap" v-if="noticeList.length > 0">
				<section class="section main-notice in-sec">
					<div class="section-header">
						<h2 class="main-tit-h2">{{ $t('sdp.menu.notice') }}</h2>
					</div>
					<div class="section-body">
						<div class="swiper-mainNotice swiper-container">
							<div class="swiper-wrapper" aria-orientation="vertical">
								<div class="swiper-slide" v-for="(notice, index) in noticeList">
									<a href="javascript:;" @click="retrieveNoticeInfo(notice.seqNo)">
										<span class="tit" :class="firstNoticeCheck(index)">
											<template v-if="notice.newFlg == 'Y'">
												<em class="label-type3">NEW</em>
											</template>
											{{ notice.titleName }}
										</span>
										<span class="txt-date">[{{ notice.cDate }}]</span>
									</a>
								</div>
							</div>
							<div class="swiper-controller centered-r-desktop"> <!-- 2023.06 웹접근성 보완 : 해당 버튼 노출을 위해 centered-r-desktop 클래스 추가 -->
								<div class="swiper-autoplay"> <!-- 2023.06 웹접근성 보완 : 해당 버튼 노출을 위해 swiper-autoplay 컴퍼넌트 위치를 swiper-controller 내부로 이동 -->
									<button type="button" class="btn-ico btn-play" aria-hidden="true" tabindex="-1"><span><i class="ico ico-play-visual">{{ $t('gwa.alt.common.wa_label_2') }}</i></span></button>
									<button type="button" class="btn-ico btn-pause"><span><i class="ico ico-pause-visual">{{ $t('gwa.alt.common.wa_label_3') }}</i></span></button>
								</div>
								<button type="button" class="swiper-button-prev"></button>
								<button type="button" class="swiper-button-next"></button>
								<div class="swiper-pagination"></div> <!-- 2022.02.15 Add -->
							</div>
						</div>
					</div>
					<!-- 2024.06.12 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
					<a href="/main/notice" class="more-page" role="button" :title="$t('gwa.alt.common.wa_label_36')">{{ $t('gwa.alt.common.wa_label_36') }} <i class="ico ico-more centered-r"></i></a> <!-- 2022.02.15 Add -->
				</section>
			</div>
			<!-- //공지사항 -->

			<!-- TV 앱 -->
			<!-- 고도화 ver2 : 속성 더보기 aria-label 수정 -->
			<!-- 고도화 ver3 : 탭전환시 스와이퍼 UI처리 -->
			<div class="section-wrap main-tvapp-wrap">
				<section class="section in-sec">
					<div class="section-header">
						<h2 class="main-tit-h2">{{ $t('sdp.menu.gnb.tvapp') }}</h2>
					</div>
					<div class="section-body">
						<div class="tab-wrap">
							<div class="tab-nav tab-change tab-type2">
								<!-- 2024.06.13 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
								<ul role="tablist">
									<li role="presentation" class="is-active"><a href="#tabContent11" role="tab" aria-controls="tabContent11" aria-selected="true">{{ $t('sdp.main.store.tap_premium') }}</a></li>
									<li role="presentation"><a href="#tabContent12" role="tab" aria-controls="tabContent12" aria-selected="false">{{ $t('sdp.main.store.tap_hot') }}</a></li>
									<li role="presentation"><a href="#tabContent13" role="tab" aria-controls="tabContent13" aria-selected="false">{{ $t('sdp.main.store.tap_new') }}</a></li>
								</ul>
							</div>
							<div class="tab-body">
								<!-- 탭내용1 -->
								<div id="tabContent11" class="tab-content is-active" aria-hidden="false">
									<!-- 2024.06.17 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
									<h3 class="blind">{{ $t('gwa.alt.home.wa_alt_1') }}</h3><!-- role="tabpanel"(안읽어줌) 대체텍스트(Tab Panel) 직접입력  -->
									<div class="tab-inner">
										<!-- 앱목록 전체영역 -->
										<div class="app-lists-wrap">
											<!-- 목록그룹  -->
											<!-- 대체텍스트 형식 alt="[제목] + App Icon" -->
											<div v-if="loadingYn == 'Y'" class="section-body">
												<div class="loading-wrap">
													<div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
												</div>
											</div>
											<template v-if="loadingYn == 'N' && premiumAppList.length > 0">
												<div class="app-lists swiper-mainTvapp swiper-container type-premium" data-type="image">
													<ul class="swiper-wrapper">
														<!-- S : 2022.02.15 Mod - 변경된 TV 앱 리스트 구조이며 PREMIUM, HOT, NEW 모두 동일한 구조로 되어 있음(스크린샷 노출이 필요한 Tab일 경우 '<div class="app-lists swiper-mainTvapp swiper-container~'에 'screenshot-img' class 추가) -->
                                                        <li class="swiper-slide" v-for="premiumApp in premiumAppList">
															<a v-if="premiumApp.age >= 18 && userAge < 18" href="javascript:;" :title="$t('gwa.alt.common.wa_title_33')" @click="setAdultAppName(premiumApp.appName, premiumApp.appId)" class="popup-open" aria-controls="popupInfoGuide" aria-haspopup="true">
															<div class="item-wrap">
                                                                    <dl>
                                                                        <dt class="item-thumb thumbnail"><img :src="premiumApp.filePthName" :alt="$t('gwa.alt.integrated.wa_label_2', {var1: premiumApp.appName})" onerror="imageResize.reset(this)" /></dt><!-- alt 태그만 제공 -->
                                                                        <dd>
                                                                            <p class="item-tit"><strong>{{ premiumApp.appName }}</strong></p>
                                                                            <p class="item-part">{{ premiumApp.catName }}</p>
                                                                            <p class="item-star">
                                                                                <span class="js starRating-label" role="text" aria-valuemax="5" aria-valuemin="0" :aria-valuenow="appStar(premiumApp.avgSscr)" :aria-label="$t('gwa.alt.integrated.wa_label_3', {var1 : appStar(premiumApp.avgSscr)})">
																					<span class="blind dv-pc-only">{{ $t('gwa.alt.integrated.wa_label_3', {var1 : appStar(premiumApp.avgSscr)}) }}</span>
																					<span class="rating"><span class="rating-max"></span><span class="rating-now"></span></span>
																				</span>
                                                                            </p>
                                                                        </dd>
                                                                    </dl>
                                                                </div>
															</a>
                                                            <a href="javascript:;" :aria-label="premiumApp.appName" :title="$t('gwa.alt.common.wa_title_33')" @click="goTvappDetail(premiumApp.appId)">
                                                                <div class="item-wrap">
                                                                    <dl>
                                                                        <dt class="item-thumb thumbnail"><img :src="premiumApp.filePthName" :alt="$t('gwa.alt.integrated.wa_label_2', {var1: premiumApp.appName})" onerror="imageResize.reset(this)" /></dt><!-- alt 태그만 제공 -->
                                                                        <dd>
                                                                            <p class="item-tit"><strong>{{ premiumApp.appName }}</strong></p>
                                                                            <p class="item-part">{{ premiumApp.catName }}</p>
                                                                            <p class="item-star">
                                                                                <span class="js starRating-label" role="text" aria-valuemax="5" aria-valuemin="0" :aria-valuenow="appStar(premiumApp.avgSscr)" :aria-label="$t('gwa.alt.integrated.wa_label_3', {var1 : appStar(premiumApp.avgSscr)})">
																					<span class="blind dv-pc-only">{{ $t('gwa.alt.integrated.wa_label_3', {var1 : appStar(premiumApp.avgSscr)}) }}</span>
																					<span class="rating"><span class="rating-max"></span><span class="rating-now"></span></span>
																				</span>
                                                                            </p>
                                                                        </dd>
                                                                    </dl>
                                                                </div>
                                                            </a>
                                                        </li>
                                                        <!-- E : 2022.02.15 Mod - 변경된 TV 앱 리스트 구조 -->
													</ul>
												</div>
												<button type="button" class="swiper-button-prev"></button>
												<button type="button" class="swiper-button-next"></button>
												<div class="swiper-pagination"></div>
											</template>
											<!-- 미등록게시물 -->
											<div class="noData-wrap" v-if="loadingYn == 'N' && premiumAppList.length == 0">
												<div class="noData">
													<div class="inner">
														<p><i class="ico ico-waring2"></i><span class="noData-txt">{{ $t('sdp.support.message.nolist') }}</span></p>
													</div>
												</div>
											</div>
											<!-- //미등록게시물 -->
											<!-- //목록그룹  -->
										</div>
										<!-- //앱목록 전체영역 -->
										<router-link to="/main/tvapp" tag="a" class="more-page" role="button" :aria-label="$t('gwa.alt.home.wa_alt_2')">
											<!-- 2024.06.13 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
											<template v-if="cntryCode == 'KR'">{{ morePageIconText1 }}</template>
											<template v-else>{{ $t('sdp.store.message.showdescription') }}</template>
											<i class="ico ico-more centered-r" id="tvappMoreIcon1"></i>
										</router-link>
									</div>
								</div>
								<!-- //탭내용1 -->
								<!-- 탭내용2 -->
								<div id="tabContent12" class="tab-content" aria-hidden="true">
									<!-- 2024.06.17 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
									<h3 class="blind">TV앱 HOT</h3><!-- role="tabpanel"(안읽어줌) 대체텍스트(Tab Panel) 직접입력  -->
									<div class="tab-inner">
										<!-- 앱목록 전체영역 -->
										<div class="app-lists-wrap">
											<!-- 목록그룹 -->
											<!-- 대체텍스트 형식 alt="[제목] + App Icon" -->
											<div v-if="loadingYn == 'Y'" class="section-body">
												<div class="loading-wrap">
													<div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
												</div>
											</div>
											<template v-if="loadingYn == 'N' && hotAppList.length > 0">
												<div class="app-lists swiper-mainTvapp swiper-container type-hot" data-type="image">
													<ul class="swiper-wrapper">
														<!-- S : 2022.02.15 Mod - 변경된 TV 앱 리스트 구조이며 PREMIUM, HOT, NEW 모두 동일한 구조로 되어 있음(스크린샷 노출이 필요한 Tab일 경우 '<div class="app-lists swiper-mainTvapp swiper-container~'에 'screenshot-img' class 추가) -->
                                                        <li class="swiper-slide" v-for="(hotApp) in hotAppList">
															<a v-if="hotApp.age >= 18 && userAge < 18" href="javascript:;" :title="$t('gwa.alt.common.wa_title_33')" @click="setAdultAppName(hotApp.appName, hotApp.appId)" class="popup-open" aria-controls="popupInfoGuide" aria-haspopup="true">
																<div class="item-wrap">
																	<dl>
																		<dt class="item-thumb thumbnail"><img :src="hotApp.appPath" :alt="$t('gwa.alt.integrated.wa_label_2', {var1: hotApp.appName})" onerror="imageResize.reset(this)" /></dt><!-- alt 태그만 제공 -->
																		<dd>
																			<p class="item-tit"><strong>{{ hotApp.appName }}</strong></p>
																			<p class="item-part">{{ hotApp.catName }}</p>
																			<p class="item-star">
																				<span class="js starRating-label" role="text" aria-valuemax="5" aria-valuemin="0" :aria-valuenow="appStar(hotApp.avgSscr)" :aria-label="$t('gwa.alt.integrated.wa_label_3', {var1 : appStar(hotApp.avgSscr)})">
																					<span class="blind dv-pc-only">{{ $t('gwa.alt.integrated.wa_label_3', {var1 : appStar(hotApp.avgSscr)}) }}</span>
																					<span class="rating"><span class="rating-max"></span><span class="rating-now"></span></span>
																				</span>
																			</p>
																		</dd>
																	</dl>
																</div>
															</a>
															<a v-else href="javascript:;" :aria-label="hotApp.appName" :title="$t('gwa.alt.common.wa_title_33')" @click="goTvappDetail(hotApp.appId)">
																<div class="item-wrap">
																	<dl>
																		<dt class="item-thumb thumbnail"><img :src="hotApp.appPath" :alt="$t('gwa.alt.integrated.wa_label_2', {var1: hotApp.appName})" onerror="imageResize.reset(this)" /></dt><!-- alt 태그만 제공 -->
																		<dd>
																			<p class="item-tit"><strong>{{ hotApp.appName }}</strong></p>
																			<p class="item-part">{{ hotApp.catName }}</p>
																			<p class="item-star">
																				<span class="js starRating-label" role="text" aria-valuemax="5" aria-valuemin="0" :aria-valuenow="appStar(hotApp.avgSscr)" :aria-label="$t('gwa.alt.integrated.wa_label_3', {var1 : appStar(hotApp.avgSscr)})">
																					<span class="blind dv-pc-only">{{ $t('gwa.alt.integrated.wa_label_3', {var1 : appStar(hotApp.avgSscr)}) }}</span>
																					<span class="rating"><span class="rating-max"></span><span class="rating-now"></span></span>
																				</span>
																			</p>
																		</dd>
																	</dl>
																</div>
															</a>
                                                        </li>
                                                        <!-- E : 2022.02.15 Mod - 변경된 TV 앱 리스트 구조 -->
													</ul>
												</div>
												<button type="button" class="swiper-button-prev"></button>
												<button type="button" class="swiper-button-next"></button>
												<div class="swiper-pagination"></div>
											</template>
											<!-- 미등록게시물 -->
											<div class="noData-wrap" v-if="loadingYn == 'N' && hotAppList.length == 0">
												<div class="noData">
													<div class="inner">
														<p><i class="ico ico-waring2"></i><span class="noData-txt">{{ $t('sdp.support.message.nolist') }}</span></p>
													</div>
												</div>
											</div>
											<!-- //미등록게시물 -->
											<!-- //목록그룹 -->
										</div>
										<!-- //앱목록 전체영역 -->
										<router-link to="/main/tvapp" tag="a" class="more-page" role="button" :aria-label="$t('gwa.alt.home.wa_alt_3')">
											<!-- 2024.06.13 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
											<template v-if="cntryCode == 'KR'">{{ morePageIconText2 }}</template>
											<template v-else>{{ $t('sdp.store.message.showdescription') }}</template>
											<i class="ico ico-more centered-r" id="tvappMoreIcon2"></i>
										</router-link>
									</div>
								</div>
								<!-- //탭내용2 -->
								<!-- 탭내용3 -->
								<div id="tabContent13" class="tab-content" aria-hidden="true">
									<!-- 2024.06.17 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
									<h3 class="blind">TV앱 NEW</h3><!-- role="tabpanel"(안읽어줌) 대체텍스트(Tab Panel) 직접입력  -->
									<div class="tab-inner">
										<!-- 앱목록 전체영역 -->
										<div class="app-lists-wrap">
											<!-- 목록그룹 -->
											<!-- 대체텍스트 형식 alt="[제목] + App Icon" -->
											<div v-if="loadingYn == 'Y'" class="section-body">
												<div class="loading-wrap">
													<div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
												</div>
											</div>
											<template v-if="loadingYn == 'N' && newAppList.length > 0">
												<div class="app-lists swiper-mainTvapp swiper-container type-new screenshot-img" data-type="image">
													<ul class="swiper-wrapper">
														<!-- S : 2022.02.15 Mod - 변경된 TV 앱 리스트 구조이며 PREMIUM, HOT, NEW 모두 동일한 구조로 되어 있음(스크린샷 노출이 필요한 Tab일 경우 '<div class="app-lists swiper-mainTvapp swiper-container~'에 'screenshot-img' class 추가) -->
                                                        <li class="swiper-slide" v-for="(newApp) in newAppList">
															<a v-if="newApp.age >= 18 && userAge < 18" href="javascript:;" :title="$t('gwa.alt.common.wa_title_33')" @click="setAdultAppName(newApp.appName, newApp.appId)" class="popup-open" aria-controls="popupInfoGuide" aria-haspopup="true">
																<div class="item-wrap">
																	<p class="screenshot"><img :src="newApp.appScreenPath" :alt="$t('gwa.alt.integrated.wa_label_2', {var1: newApp.appName})" onerror="imageResize.reset(this)" /></p>
																	<dl>
																		<dt class="item-thumb thumbnail"><img :src="newApp.appPath" :alt="$t('gwa.alt.integrated.wa_label_2', {var1: newApp.appName})" onerror="imageResize.reset(this)" /></dt><!-- alt 태그만 제공 -->
																		<dd>
																			<p class="item-tit"><strong>{{ newApp.appName }}</strong></p>
																			<p class="item-part">{{ newApp.catName }}</p>
																			<p class="item-star">
																				<span class="js starRating-label" role="text" aria-valuemax="5" aria-valuemin="0" :aria-valuenow="appStar(newApp.avgSscr)" :aria-label="$t('gwa.alt.integrated.wa_label_3', {var1 : appStar(newApp.avgSscr)})">
																					<span class="blind dv-pc-only">{{ $t('gwa.alt.integrated.wa_label_3', {var1 : appStar(newApp.avgSscr)}) }}</span>
																					<span class="rating"><span class="rating-max"></span><span class="rating-now"></span></span>
																				</span>
																			</p>
																		</dd>
																	</dl>
																</div>
															</a>
															<a v-else href="javascript:;" :aria-label="newApp.appName" :title="$t('gwa.alt.common.wa_title_33')" @click="goTvappDetail(newApp.appId)">
																<div class="item-wrap">
																<p class="screenshot"><img :src="newApp.appScreenPath" :alt="$t('gwa.alt.integrated.wa_label_2', {var1: newApp.appName})" onerror="imageResize.reset(this)" /></p>
																	<dl>
																		<dt class="item-thumb thumbnail"><img :src="newApp.appPath" :alt="$t('gwa.alt.integrated.wa_label_2', {var1: newApp.appName})" onerror="imageResize.reset(this)" /></dt><!-- alt 태그만 제공 -->
																		<dd>
																			<p class="item-tit"><strong>{{ newApp.appName }}</strong></p>
																			<p class="item-part">{{ newApp.catName }}</p>
																			<p class="item-star">
																				<span class="js starRating-label" role="text" aria-valuemax="5" aria-valuemin="0" :aria-valuenow="appStar(newApp.avgSscr)" :aria-label="$t('gwa.alt.integrated.wa_label_3', {var1 : appStar(newApp.avgSscr)})">
																					<span class="blind dv-pc-only">{{ $t('gwa.alt.integrated.wa_label_3', {var1 : appStar(newApp.avgSscr)}) }}</span>
																					<span class="rating"><span class="rating-max"></span><span class="rating-now"></span></span>
																				</span>
																			</p>
																		</dd>
																	</dl>
																</div>
															</a>
                                                        </li>
                                                        <!-- E : 2022.02.15 Mod - 변경된 TV 앱 리스트 구조 -->
													</ul>
												</div>
												<button type="button" class="swiper-button-prev"></button>
												<button type="button" class="swiper-button-next"></button>
												<div class="swiper-pagination"></div>
											</template>
											<!-- 미등록게시물 -->
											<div class="noData-wrap" v-if="loadingYn == 'N' && newAppList.length == 0">
												<div class="noData">
													<div class="inner">
														<p><i class="ico ico-waring2"></i><span class="noData-txt">{{ $t('sdp.support.message.nolist') }}</span></p>
													</div>
												</div>
											</div>
											<!-- //미등록게시물 -->
											<!-- //목록그룹 -->
										</div>
										<!-- //앱목록 전체영역 -->
										<router-link to="/main/tvapp" tag="a" class="more-page" role="button" :aria-label="$t('gwa.alt.home.wa_alt_4')">
											<!-- 2024.06.13 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
											<template v-if="cntryCode == 'KR'">{{ morePageIconText3 }}</template>
											<template v-else>{{ $t('sdp.store.message.showdescription') }}</template>
											<i class="ico ico-more centered-r" id="tvappMoreIcon3"></i>
										</router-link>
									</div>
								</div>
								<!-- //탭내용3 -->
							</div>
						</div>
					</div>
				</section>
			</div>
			<!-- //TV 앱 -->

			<!-- 자가진단 -->
			<div class="section-wrap main-selftest-wrap">
				<section class="section">
					<div class="section-header in-sec">
						<h2 class="main-tit-h2 type2">{{ $t('sdp.menu.gnb.self') }}</h2>
					</div>
					<div v-if="loadingYn == 'Y'" class="section-body">
						<div class="loading-wrap">
							<div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
						</div>
					</div>
					<div class="section-body" v-else>
						<!-- start-2023.06.15 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년 -->
						<template v-if="diagList.length > 0">
              <div class="swiper-mainSelftest"> <!-- 2025.05.02 Mod 웹접근성 대응 -->
								<div class="swiper-container">
									<ul class="swiper-wrapper">
										<li class="swiper-slide col" v-for="diag in diagList">
											<div class="item" :style="'background-image:url('+diag.resourcePth+')'">
												<a href="javascript:;" class="item-link" role="button" @click="updateDiagViewCnt(diag.seqNo, diag.catCode1)">
													<span><span class="category"><em>{{ diag.catName }}</em></span>{{ diag.titleName }}</span>
												</a>
											</div>
										</li>
									</ul>
								</div>
                <button type="button" class="swiper-button-prev"></button> <!-- 2025.05.02 Add 웹접근성 대응 -->
                <button type="button" class="swiper-button-next"></button> <!-- 2025.05.02 Add 웹접근성 대응 -->
                <div class="swiper-pagination swiper-pagination-selftest"></div> <!-- 2025.05.02 Add 웹접근성 대응 -->
							</div>
							<!-- 2023.06 웹접근성 보완 :
								1. focus 이동시 하단 controller가 보이지 않는 이슈를 픽스하기 위해 컴퍼넌트의 위치 변경
								2. javsscript에 정확한 selector 제공을 위해 swiper-button-prev-selftest 클래스 추가
								3. javsscript에 정확한 selector 제공을 위해 swiper-button-next-selftest 클래스 추가
								3. javsscript에 정확한 selector 제공을 위해 swiper-pagination-selftest 클래스 추가
							-->
              <!-- <button type="button" class="swiper-button-prev swiper-button-prev-selftest"></button>
              <button type="button" class="swiper-button-next swiper-button-next-selftest"></button> -->
              <!-- <div class="swiper-pagination swiper-pagination-selftest"></div> 2025.05.02 Del 웹접근성 대응 -->
						</template>
						<template v-else>
							<!-- 미등록게시물 -->
							<div class="noData-wrap in-sec">
								<div class="noData">
									<div class="inner">
										<p><i class="ico ico-waring2"></i><span class="noData-txt">{{ $t('sdp.support.message.nolist') }}</span></p>
									</div>
								</div>
							</div>
							<!-- //미등록게시물 -->
						</template>
						<!-- end-2023.06.15 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년 -->
					</div>
					<!-- 2024.06.12 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
					<a href="/main/diag" class="more-page" role="button" :title="$t('gwa.alt.common.wa_title_26')">{{ $t('gwa.alt.common.wa_title_26') }}</a>
				</section>
			</div>
			<!-- //자가진단 -->

			<!-- 빠른메뉴 -->
			<div class="section-wrap main-quick-wrap">
				<section class="section in-sec" aria-labelledby="quickTitle">
					<div class="section-header">
						<h2 class="main-tit-h2" hidden id="quickTitle">{{ $t('gwa.alt.home.wa_alt_5') }}</h2>
					</div>
					<div class="section-body grid-wrap">
						<!-- 2024.03.25 송준형 : REQSDP-4355 - [PC mall] lgappstv.com에 연계되어 있는 LG Smart World 삭제 -->
						<ul class="quick-lists grid" style="display:flex; justify-content:center; flex-wrap: wrap;">
							<li class="col">
								<div class="item item-quick1">
									<router-link to="/main/faq" class="item-link" role="button">
										<i class="ico ico-faq"></i>
										<span>{{ $t('sdp.menu.faq') }}</span>
									</router-link>
								</div>
							</li>
							<li class="col">
								<div class="item item-quick2"> 
									<!-- N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의) 2019.07.11 김남중 -->
									<router-link to="/main/inquiry/register" class="item-link" role="button">
										<i class="ico ico-ques"></i>
										<span v-html="$t('sdp.menu.qna_quick')"></span>
									</router-link>
								</div>
							</li>
							<li class="col">
								<div class="item item-quick3">
									<a href="https://www.lg.com/common/index.jsp" class="item-link" role="button" target="_blank" :title="$t('gwa.alt.common.wa_title_4')">
										<i class="ico ico-lgmain"></i>
										<span v-html="$t('sdp.main.main.website')"></span>
									</a>
								</div>
							</li>
							<!-- 2024.03.25 송준형 : REQSDP-4355 - [PC mall] lgappstv.com에 연계되어 있는 LG Smart World 삭제 -->
							<!--<li class="col">-->
								<!--<div class="item item-quick4">-->
									<!--<a href="http://www.lgworld.com/web.gateway.dev" class="item-link" role="button" target="_blank" :title="$t('gwa.alt.common.wa_title_4')">-->
										<!--<i class="ico ico-mobile"></i>-->
										<!--<span>LG Smart World<br>(Mobile)</span>-->
									<!--</a>-->
								<!--</div>-->
							<!--</li>-->
							<li class="col">
								<div class="item item-quick5">
									<a href="http://seller.lgappstv.com/seller/main/Main.lge" class="item-link" role="button" target="_blank" :title="$t('gwa.alt.common.wa_title_4')">
										<i class="ico ico-seller"></i>
										<span>{{ $t('sdp.menu.seller_guide') }}</span>
									</a>
								</div>
							</li>
							<li class="col">
								<div class="item item-quick6">
									<a href="http://webostv.developer.lge.com/" class="item-link" role="button" target="_blank" :title="$t('gwa.alt.common.wa_title_4')">
										<i class="ico ico-developer"></i>
										<span>{{ $t('sdp.menu.developer_guide') }}</span>
									</a>
								</div>
							</li>
						</ul>
					</div>
				</section>
			</div>
			<!-- //빠른메뉴 -->

			<!-- 팝업_APP이용안내 -->
			<div id="popupInfoGuide" class="popup-wrap" hidden>
				<div class="popup popup-type1" role="dialog" aria-labelledby="popupInfoGuideTitle">
					<div class="blind-area popup-focus dv-ios-only" role="text" :aria-label="$t('gwa.alt.common.wa_label_55')"><!-- IOS접근성 영역자체에 초점처리 --></div>
					<div class="popup-container">
						<div class="popup-header">
							<h3 class="tit-h3" id="popupInfoGuideTitle">APP {{ $t("sdp.menu.overview") }}</h3>
						</div>
						<div class="popup-body popup-scroll">
							<div class="para-wrap align-c">
								<p class="para color-primary" v-html="$t('sdp.store.message.minorsapp')"></p>
								<p class="para" v-html="$t('sdp.store.minorsapp.detailinfo', { var1 : adultAppName })"></p>
							</div>
						</div>
						<div class="popup-footer">
							<div class="btn-wrap">
								<button @click="goLgaccount('N')" type="button" class="btn btn-type2 btn-primary"><span>{{ $t("sdp.menu.join_member") }}</span></button>
								<button @click="goLgaccount('Y')" type="button" class="btn btn-type2 btn-primary"><span>{{ $t("sdp.menu.gnb.lgaccount") }}</span></button>
								<button type="button" class="btn btn-type2 btn-secondary popup-close" aria-controls="popupInfoGuide"  :title="$t('gwa.alt.common.wa_title_58')"><span>{{ $t("sdp.message.layerpopup.close") }}</span></button>
							</div>
						</div>
						<button type="button" class="btn-ico btn-popup-close popup-close" aria-controls="popupInfoGuide" :title="$t('gwa.alt.common.wa_title_58')"><span><i class="ico ico-close2">{{ $t('sdp.message.layerpopup.close') }}</i></span></button>
					</div>
				</div>
			</div>
			<!-- //팝업_APP 이용안내 -->

			<!-- start-2023.06.14 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년 -->
			<!-- 팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
			<div v-show="cntryCode == 'FR'">
				<TermsPop></TermsPop>
			</div>
			<!-- //팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
			<!-- end-2023.06.14 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년 -->
		</div>
		<!-- //Main ContentsBody -->

	</section>
</template>

<script>

	import qs from "qs";
    import TermsPop from '@/components/terms/TermsPop';

	export default {
	  name: "Home",
        components: {
            TermsPop
        },
	  data() {
		  return {
			  bannerList : [],
			  noticeList : [],
			  premiumAppList : [],
			  hotAppList : [],
			  newAppList : [],
			  diagList : [],
              diagSeqNo : 0,
			  diagCatCode1 : 0,
			  userAge: 0,
              adultAppName: "",
			  adultAppId: "",
			  loadingYn: "Y",
			  bannerSize : 20,
			  domainPrefix : "", // C20200921_05798 : PC Website Promotion Banner 기간 설정 기능 추가, 사용성 현황(클릭수) 추가 - 2020.09.21 송준형
			  cntryCode: _domainCntryCode,
			  iosFlag: 0 // ios:11, ipad:12, ipop:13, .... 20:mac(mac관련은 11~20 까지), 이외는 모두 1~10(android, window, chrome, explo...)
		  }
	  },
	  created() {
	  },
	  computed: {
          morePageIconText1: function() { // 2024.06.13 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년
              if($("#tvappMoreIcon1").css("display") == "none") {
                  return this.$t("gwa.alt.home.wa_alt_2");
			  } else {
                  return this.$t("sdp.store.message.showdescription");
			  }
          },
          morePageIconText2: function() { // 2024.06.13 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년
              if($("#tvappMoreIcon2").css("display") == "none") {
                  return this.$t("gwa.alt.home.wa_alt_3");
              } else {
                  return this.$t("sdp.store.message.showdescription");
              }
          },
          morePageIconText3: function() { // 2024.06.13 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년
              if($("#tvappMoreIcon3").css("display") == "none") {
                  return this.$t("gwa.alt.home.wa_alt_4");
              } else {
                  return this.$t("sdp.store.message.showdescription");
              }
          }
	  },
	  methods: {
		  track () {
				console.log('@@@@ track:', this.$router.currentRoute.path);
				this.$ga.page(this.$router.currentRoute.path)
			},
          bannerClick(url) {

		      if (url == null || url == '') {
		          return;
			  } else {
                  // [START] C20200921_05798 : PC Website Promotion Banner 기간 설정 기능 추가, 사용성 현황(클릭수) 추가 - 2020.09.07 송준형
		          var bannerUrl = "https://" + this.domainPrefix + this.cntryCode + ".lgappstv.com/main/bannerLink?";
		          bannerUrl += "bannerUrl=" + encodeURIComponent(url) + "&bannerType=main";
                  // [END] C20200921_05798 : PC Website Promotion Banner 기간 설정 기능 추가, 사용성 현황(클릭수) 추가 - 2020.09.07 송준형

                  //window.open(url, '_blank');
                  // start- C20190723_47503 : 2019.08.08 김남중 - 옴니추어 Main Swiper 배너 이미지 Link
	              const params = {
                         url: bannerUrl,
                         banner: 'banner'
   	              };

	              // window navigator
            	  var userAgent = window.navigator.userAgent;
            	  var isChrome = userAgent.indexOf('Chrome');
            	  var isChromeMobile = userAgent.indexOf('CriOS');
            	  var isSamsungBrowser = userAgent.indexOf('SamsungBrowser');
            	  var isFirefox = userAgent.indexOf('Firefox');
            	  var isEdge = userAgent.indexOf('Edge');
            	  var browse = userAgent.toLowerCase();
            	  var isIe = browse.indexOf("msie");
            	  var isIeMinu = browse.indexOf("trident");
            	  // window Open
            	  // - Chrom/Firefox의 경우 간혹 "domain/_blank"로 되어 not found 후 emp이용약관으로 이동하여 현재 페이지open 후 이동하도록 처리함.
            	  // - PC 익스플로러는 팝업차단 우회 막혀서 안됨.
            	  var popWindow;
            	  var baseWinurl = window.location;
                  //console.log("baseWinurl:", baseWinurl.origin);
            	  if ((navigator.appName == 'Netscape' && isIeMinu > -1) || isIe > -1) {}
         	  	  else if (isSamsungBrowser > -1) { popWindow = window.open(); }
         	  	  else if (isChrome > -1 || isFirefox > -1) { popWindow = window.open(baseWinurl, '_blank'); }
         	  	  else { popWindow = window.open('_blank'); }

                  this.$axios.post('', qs.stringify(params)).then((result) => {
                	  // C20190819_65828 : 2019.08.22 김남중 - PC Website Main Promotion Banner 링크 오류 수정
                	  //                   - this.$axios.post('main:banner', 와 window.open(url, '_blank') 변경
                	  //window.open(url, '_blank');
                	  /* var popWindow = window.open('_blank');
                	  popWindow.location.href = url; */
                	  // 브라우저 체크(IE의 경우 팝업 우회불가함.)
                	  if ((navigator.appName == 'Netscape' && isIeMinu > -1) || isIe > -1) {
                		  window.open(bannerUrl, '_blank');
                	  } else {
                		  //var popWindow = window.open('_blank');
                    	  popWindow.location.href = bannerUrl;
                	  }
                	  /* // pc, mobile의 크롬 브라우저 체크 //var isWindows = userAgent.indexOf('Windows NT'); //var isIE = userAgent.indexOf('Trident');
               	      var userAgent = window.navigator.userAgent; var isChrome = userAgent.indexOf('Chrome'); var isChromeMobile = userAgent.indexOf('CriOS'); var isSamsungBrowser = userAgent.indexOf('SamsungBrowser'); var isEdge = userAgent.indexOf('Edge');
               	      // 크롬 브라우저 체크
               	      if (isChrome > -1 || isChromeMobile > -1) { if (isSamsungBrowser < 0 && isEdge < 0) { //setTimeout(function() { popWindow.close(); }, 500); } } */
   	              }).catch((err) => {
   	            	  alert("error : " + err);
   	              });
                  // end- C20190723_47503 : 2019.08.08 김남중 - 옴니추어 Main Swiper 배너 이미지 Link
			  }
		  },
          appStar (avgSscr) {
              if (avgSscr >= 9.5) {
                  return 5;
              } else if (avgSscr >= 8.5) {
                  return 4.5;
              } else if (avgSscr >= 7.5) {
                  return 4;
              } else if (avgSscr >= 6.5) {
                  return 3.5;
              } else if (avgSscr >= 5.5) {
                  return 3;
              } else if (avgSscr >= 4.5) {
                  return 2.5;
              } else if (avgSscr >= 3.5) {
                  return 2;
              } else if (avgSscr >= 2.5) {
                  return 1.5;
              } else if (avgSscr >= 1.5) {
                  return 1;
              } else if (avgSscr >= 0.5) {
                  return 0.5;
              } else {
                  return 0;
              }
          },
          retrieveNoticeInfo(seqNo) {
              const r = { path : `/main/notice/detail?seqNo=${seqNo}`+`&keyword=&curPage=1`};
              this.$router.push(r);
          },
          updateDiagViewCnt(seqNo, catCode1) {
              const vm = this;
              vm.diagSeqNo = seqNo;

              const params = {
                  seqNo: vm.diagSeqNo
              };

              this.$axios.post("/api/diag/updateDiagViewCnt.ajax",
                  qs.stringify(params)).then((result) => {
                  const r = { path : "/main/diag/detail?seqNo=" + vm.diagSeqNo + "&catCode1="
                          + catCode1 + "&searchYn=N&allClickYn=N&schTxt=&curPage=1" };
                  this.$router.push(r);
              }).catch((err) => {
                  alert("error : " + err);
              });
          },
          goTvappDetail(appId) {
              const r = { path : "/main/tvapp/detail?appId=" + appId
					  + "&catCode1=&moreYn=N&cateYn=N&orderType=0&headerName=&appRankCode=&sellrUsrNo=" };
              this.$router.push(r);
          },
          setAdultAppName(appName, appId) {
              this.adultAppName = appName;
              this.adultAppId = appId;
          },
          firstNoticeCheck(index) {
		      if(index == 0) {
		          return "color-primary";
			  } else {
		          return "";
			  }
		  },
          goLgaccount(loginYn) {
              const vm = this;

              var _params = {
                  appId: vm.adultAppId,
                  catCode1: "",
                  moreYn: "N",
                  cateYn: "N",
                  orderType: "0",
                  headerName: "",
                  appRankCode: "",
                  sellrUsrNo: ""
              };

              // 2024.12.17 송준형 : REQSDP-6333 - PCMall LMP(멤버스) 로그인 연동 방식 개선 개발
              var loginPath = "tvapp/detail?" + qs.stringify(_params);
              const r = { path : "/main/loginLink?path=" + loginPath.replaceAll("&", "-") + "&loginYn=" + loginYn };
              this.$router.push(r);
          }
	  },
	mounted() {
		// console.log('document.cookie: ', document.cookie);

        // ui.searchAll.close('searchAll'); // 검색바 닫힘

		const vm = this;
		ui.loading.open();

		this.$axios.post("/api/main/retrieveMain.ajax").then((result) => {
			vm.$nextTick(function () {
			    ui.loading.close();
				vm.bannerList = result.data.items.bannerList;
				vm.noticeList = result.data.items.noticeList;
				vm.premiumAppList = result.data.items.premiumAppList;
				vm.hotAppList = result.data.items.hotAppList;
				vm.newAppList = result.data.items.newAppList;
				vm.diagList = result.data.items.diagList;
				vm.userAge = result.data.items.userAge;
				vm.domainPrefix = result.data.items.domainPrefix; // C20200921_05798 : PC Website Promotion Banner 기간 설정 기능 추가, 사용성 현황(클릭수) 추가 - 2020.09.21 송준형
				vm.loadingYn = "N";
				
				vm.$nextTick(function() {
					ui.init();
				})
			})
		}).catch((err) => {
            ui.loading.close();
            vm.loadingYn = "N";
			alert('error : ' + err);
		});
	}
	};
</script>

